// extracted by mini-css-extract-plugin
module.exports = {"checkbox_description":"CheckBox_checkbox_description__Rg_ll","checkbox_row":"CheckBox_checkbox_row__3BUYy"};